"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MEDIUM_CELL_WIDTH = exports.MAX_SMALL_CELL_WIDTH = exports.MIN_MEDIUM_CELL_WIDTH = exports.MIN_SMALL_CELL_WIDTH = void 0;
exports.MIN_SMALL_CELL_WIDTH = 240;
exports.MIN_MEDIUM_CELL_WIDTH = 420;
exports.MAX_SMALL_CELL_WIDTH = 320;
exports.MAX_MEDIUM_CELL_WIDTH = 620;
